import { AddressBookAddressValidationTag } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const addressBookAddressValidationTag = (options: AddressBookAddressValidationTag) => {
  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );

  const addressBookAddressValidationEvent = [
    {
      eventInfo: {
        eventName: 'recipient address',
        eventAction: 'address book upload',
      },
    },
    {
      eventInfo: {
        eventName: 'invalid address',
        eventAction: options.action,
      },
    },
  ];

  const { modal, user } = getPODModalTag(
    'Address the Envelope - Recipient',
    addressBookAddressValidationEvent,
    options.projectID,
  );

  return {
    modal,
    product,
    user,
  };
};
